export default {
    path : "factory-carrier-all",
    name : "factory-carrier-all",
    meta : {
        title : "全部载体"
    },
    component: () => import('@/pages/factory/allCarrier/Index'),
    redirect: {
        name : "factory-carrier-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-carrier-all-whole',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-carrier-all-recent',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-carrier-all-atme',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-carrier-all-meat',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-carrier-all-reply',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-carrier-all-search',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'factory-carrier-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/carrierCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/allcarrier/index.js